import React from "react";

interface PermissionedProps {
  userPermissions: string[];
  allowedPermissions: string[];
  fallback?: React.ReactNode;
  url: string; // We need url here for expanded sections/links to work
  selectedUrlPrefix?: string; // needed for expanded sections to work
  children: React.ReactNode;
}

export default class Permissioned extends React.Component<
  PermissionedProps,
  any
> {
  static defaultProps = {
    url: "",
  };

  render() {
    if (this.hasPermission()) {
      return <>{this.props.children}</>;
    }

    if (this.props.fallback) {
      return this.props.fallback;
    }

    return null;
  }

  hasPermission = () => {
    return this.props.allowedPermissions.some((permission) => {
      return this.props.userPermissions.includes(permission);
    });
  };
}
